import { signal } from 'services/SignalsService'

const name = 'AWAIT-GAMBLE'

async function execute() {
  signal.dispatch('GAMBLE-MODE:WIN-ANIMATION')
  return signal.promise('GAMBLE-FEATURE:DONE')
}

export function getAwaitGambleAction() {
  return {
    name,
    execute,
  }
}
